<template>
  <v-footer dark padless>
    <v-card flat tile class="secondary white--text text-center">
      <v-card-text>
        <v-btn
          v-for="(icon, i) in icons"
          :key="i"
          class="mx-4 white--text"
          :href="icon.link"
          target="_blank"
          icon
        >
          <v-icon v-if="icon.isIcon" size="24px">{{ icon.text }}</v-icon>
          <v-img v-else :src="icon.iconUrl" max-width="40px" />
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        ¿Cuánto tiempo esperarás antes de exigir lo mejor para tu empresa?
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>RMS Uy Solutions</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<style scoped>
.v-card {
  width: 100%;
}
</style>

<script>
export default {
  data: () => ({
    icons: [
      {
        isIcon:false,
        iconUrl: require("@/assets/img/x-social-media-round-icon.svg"),
        link:""
      },
      {
        isIcon:false,
        iconUrl: require("@/assets/img/tiktok_logo_icon.svg"),
        link:""
      },
      {
        isIcon:true,
        text: "mdi-youtube",
        link: "",
      },
    ],
  }),
};
</script>
